module.exports = __webpack_public_path__ + "img/logo.c4cc45f3.png";